module.exports = __webpack_public_path__ + "static/media/aa-map.e43f6f5c.png";